import React from 'react'
import ProgressiveImage from 'react-progressive-image'

import {
  ConnectIconCase,
  ConnectIconComputer,
  ConnectIconPen,
} from 'components/base/Icon/styles'

import Title from 'components/base/Title'
import Paragraph, { Theme as ParagraphTheme } from 'components/base/Paragraph'
import StartQuoteButton from 'components/base/StartQuoteButton'
import Link, { Theme as LinkTheme } from 'components/base/Link'

import GoldBgr from 'assets/images/backgrounds/bgr-gold-lg.webp'
import GoldBgr64 from 'assets/images/backgrounds/bgr-gold-lg-placeholder'

import {
  ConnectWrap,
  ConnectContent,
  ConnectItem,
} from './styles'

import type { ConnectProps } from './types'

const ConnectWithInl: React.FC<ConnectProps> = ({ trackingInfo }: ConnectProps): React.ReactElement => (
  <ProgressiveImage
    src={GoldBgr}
    placeholder={GoldBgr64}
  >
    {(src: string, loading: boolean): React.ReactElement => (
      <ConnectWrap img={src} isLoading={loading}>
        <Title level={2}>Connect with Insurance Lounge</Title>
        <ConnectContent>
          <ConnectItem>
            <ConnectIconCase />
            <Title level={3}>Careers</Title>
            <Paragraph theme={ParagraphTheme.medium}>
              We offer great growth opportunities and competitive benefits.
            </Paragraph>
            <Link theme={LinkTheme.button} to='/about-us/careers/'>
              Career Center
            </Link>
          </ConnectItem>
          <ConnectItem>
            <ConnectIconComputer />
            <Title level={3}>Contact Us</Title>
            <Paragraph theme={ParagraphTheme.medium}>
              For general questions, feel free to visit our contact page.
            </Paragraph>
            <Link theme={LinkTheme.button} to='/contact/'>
              Contact Us
            </Link>
          </ConnectItem>
          <ConnectItem>
            <ConnectIconPen />
            <Title level={3}>Get Started</Title>
            <Paragraph theme={ParagraphTheme.medium}>
              Ready to get started? Start a quote today.
            </Paragraph>
            <StartQuoteButton trackingInfo={trackingInfo}>
              Start a Quote
            </StartQuoteButton>
          </ConnectItem>
        </ConnectContent>
      </ConnectWrap>
    )}
  </ProgressiveImage>
)

export default ConnectWithInl

export * from './types'
